import { ColumnDef } from '@tanstack/react-table';

import { WebEDIRowData } from 'components/DataTable/Types';

import { ExcelColumnDefinition } from '../types';

const convertSingleColumn = (column: ColumnDef<WebEDIRowData, unknown>): ExcelColumnDefinition | null => {
  const required = Boolean(column.meta?.required);
  const label = column.meta?.label;

  if (!label || !column.id) {
    return null;
  }

  const header = required ? `${label} *` : label;

  const baseDefinition: ExcelColumnDefinition = {
    key: column.id,
    header: header,
    description: column.meta?.description,
    type: column.meta?.type,
    example: undefined,
    required: required,
    options: column.meta?.optionalConfig?.options,
  };

  if ('columns' in column && Array.isArray(column.columns) && column.columns.length > 0 && column.id) {
    const subColumns = column.columns
      .map((subColumn) => {
        return convertSingleColumn(subColumn);
      })
      .filter((col): col is Exclude<ExcelColumnDefinition, 'columns'> => col !== null);

    if (subColumns.length > 0) {
      baseDefinition.columns = subColumns;
    }
  }

  return baseDefinition;
};

/**
 * Converts DataTable column definitions to Excel column definitions
 * Handles both regular columns and grouped columns (with nested sub-columns)
 * @param columns Array of DataTable column definitions
 * @returns Array of Excel column definitions
 */
export const dataTableColumnsToExcelDefinitions = (
  columns: Array<ColumnDef<WebEDIRowData, unknown>>,
): Array<ExcelColumnDefinition> => {
  return columns
    .map((column) => convertSingleColumn(column))
    .filter((column): column is ExcelColumnDefinition => column !== null);
};
